import React, { useContext } from 'react';
import VesselAutoComplete from 'components/common/VesselAutoComplete';

// import { types } from 'constants/vesselTypes';
import { VesselDwtTypesContext } from '../TcIndexPage';
import { selectTypes } from '../common';

function Imo({ imo: _imo, countIndex, changeFieldsMultiple }) {
    const vesselDwtTypes = useContext(VesselDwtTypesContext);

    const selectVessel = (vessel) => {
        const vesselData = selectTypes(vessel, vesselDwtTypes);

        changeFieldsMultiple([
            {
                index: countIndex,
                field: 'vesselId',
                value: vessel._id || null,
            },
            {
                index: countIndex,
                field: 'vessel.imoNumber',
                value: vessel.imoNumber,
            },
            {
                index: countIndex,
                field: 'vessel.typeByPurpose',
                value: vesselData.typeByPurpose,
            },
            {
                index: countIndex,
                field: 'typeByPurpose',
                value: vesselData.typeByPurpose,
            },
            {
                index: countIndex,
                field: 'vesselDwtGroup',
                value: vesselData.vesselDwtGroup,
            },
        ]);
    };

    return (
        <VesselAutoComplete
            customValue={_imo}
            selectValue={selectVessel}
            hintText={null}
            underlineStyle={{ display: 'none' }}
            menuStyle={{ width: '300px' }}
            popoverProps={{
                style: { width: '300px' },
            }}
            inputStyle={{ fontSize: '9px' }}
            field='imoNumber'
        />
    );
}

export default React.memo(Imo);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/Imo.jsx